import { LitElement, html, css } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import fidelityLogo from "../../assets/images/fidelity-logo.svg";
class Panel extends LitElement {
	static properties = {
		active: { reflect: true, attribute: "active" },
		renderedContent: { type: String },
		name: { type: String, reflect: true },
	};

	static styles = css`
		:host {
			display: flex;
		}
		slot[name="background"] {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
		}

		slot[name="panel-content"],
		slot[name="page-content"] {
			z-index: 1;
		}

		.panel-header {
			position: fixed;
			display: flex;
			padding-left: 20px;
			padding-right: 20px;
			top: 0;
			left: 0;
			right: 0;
			justify-content: space-between;
			z-index: 3;
		}

		.panel-wrap {
			margin: auto 20px;
			padding-top: 200px;
		}

		.fancy-btn,
		::slotted(.fancy-btn) {
			background: var(--color-primary);
			color: white;
			padding: 10px 30px;
			font-weight: 500;
			display: flex;
			align-self: center;
			border-radius: 30px;
			text-decoration: none;
		}

		.page-title {
			position: sticky;
			left: 50%;
			transform: translateX(-50%);
			background: white;
			padding: 10px 25px;
			border-bottom-left-radius: 20px;
			border-bottom-right-radius: 20px;
			box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);
		}
		.page-title h1 {
			font-size: var(--fluid-h6);
			color: var(--color-primary);
		}
	`;
	constructor() {
		super();
		this.active = false;
		this.name = null;
		this.panelHref = null;
		this.wpPageID = null;
		this.renderedContent = null;
		this.panelController = null;
		this.slot = null;
		this.lottiePlayer = this.querySelector("dotlottie-player");
	}

	connectedCallback() {
		super.connectedCallback();
		this.panelController = document.querySelector("panel-controller");
		//this.lottiePlayer.pause();
	}

	openPanel() {
		this.active = true;
		console.log("I should be getting called during the first render");
		this.lottiePlayer.seek("36%");
		this.lottiePlayer.play();
		this.lottiePlayer.loop = false;
		this.lottiePlayer.addEventListener("complete", () => {
			this.lottiePlayer.seek("36%");
		});
	}

	closePanel() {
		this.active = false;
		this.lottiePlayer.pause();
	}

	/**
	 * Query the wordpress API for the content of this panel
	 * Will Set the
	 **/
	// async getPanelContent() {
	// 	// define fetch data object
	// 	if (this.active) {
	// 		try {
	// 			let json = null;
	// 			console.log("woo we got here!");
	// 			const request = await fetch("/wp-json/wp/v2/pages/?slug=home", {
	// 				method: "GET",
	// 				headers: {
	// 					"Content-Type": "application/json",
	// 				},
	// 			});
	// 			if (request.ok) {
	// 				console.log(request);
	// 				json = await request.json();
	// 				console.log(json);
	// 				this.renderedContent = json[0].content.rendered;
	// 			}
	// 		} catch (e) {
	// 			console.log("Error fetching panel content");
	// 			console.log(e);
	// 		}
	// 	}
	// }

	createRenderRoot() {
		return this;
	}

	// render() {
	// 	return html`
	// 		<header class="panel-header">
	// 			<img src="${fidelityLogo}" alt="Fidelity Logo" />
	// 			<div class="page-title">
	// 				<h1>${this.name}</h1>
	// 			</div>
	// 			<a href="/" class="fancy-btn left-arrow-btn"> Back to lobby </a>
	// 		</header>
	//
	// 		<slot name="background"></slot>
	// 		<div part="panel-content" class="panel-wrap ${this.active ? "active" : ""}">
	// 			<div part="panel-hero-section" class="panel-section">
	// 				<slot name="panel-content"></slot>
	// 				<slot name="graphic"></slot>
	// 			</div>
	// 		</div>
	// 		<section part="page-content" class="page-content">${unsafeHTML(this.renderedContent)}</section>
	// 	`;
	// }
}

window.customElements.define("custom-panel", Panel);
